import React, { useContext } from "react";
import { Badge } from "reactstrap";
import { StateContext } from "../../../utils/context";
import { Link } from "react-router-dom";

const SLALevel = () => {
  const { currentUser } = useContext(StateContext);
  const { sla_level, is_premium_user, is_employee_account } = currentUser;

  const slaConfig = {
    'Standard': {
      name: 'Standard',
      bg: '#95A5A6',
      text: '#FFFFFF',
      icon: 'mdi-lifebuoy',
    },
    'Business Lite': {
      name: 'Business Lite',
      bg: '#0A8FE8',
      text: '#FFFFFF',
      icon: 'mdi-rocket-launch',
    },
    'Business': {
      name: 'Business',
      bg: '#1E8449',
      text: '#FFFFFF',
      icon: 'mdi-handshake-outline',
    },
    'Gold': {
      name: 'Gold',
      bg: '#F4D03F',
      text: '#000000',
      icon: 'mdi-diamond-stone',
    },
  };

  const config = slaConfig[sla_level] || {
    name: '',
    bg: '#C0C0C0',
    text: '#000000',
    icon: '',
  };

  return (
    <>
      {(is_premium_user || is_employee_account) &&
        <Link to="/sla/">
          <Badge
            className="mt-3 mr-3 p-2 d-flex align-items-center"
            style={{
              backgroundColor: config.bg,
              color: config.text,
            }}
          >
            <span
              className="text-uppercase font-weight-medium mr-2"
              style={{ fontSize: '12px', fontWeight: 'bold', opacity: 0.8 }}
            >
              SLA Level
            </span>
            <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
              {config.name}
            </span>
            {config.icon && <i className={`ml-2 mdi ${config.icon}`}></i>}
          </Badge>
        </Link>
      }
    </>
  );
};

export default SLALevel;